import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { USE_CASES } from "../data/useCases";
import { getToolBySlug } from "../data/tools";

export default function UseCasesIndex() {
  return (
    <>
      <SEO title="Best AI Writing Tools by Use Case" description="Which AI writing tool wins for LinkedIn bios, cold email, product descriptions, blog SEO, social media, and ad copy — tested use case by use case." />
      <section className="pt-36 pb-20 px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono-tag text-xs uppercase tracking-[0.2em] text-gold mb-4">By Use Case</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="font-display font-black text-4xl sm:text-5xl text-white tracking-tight max-w-2xl">The Best Tool Depends on What You Write</motion.h1>
          <p className="text-zinc-400 mt-4 max-w-xl">We tested each tool separately for six specific writing jobs — here's the winner for each.</p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
            {USE_CASES.map((uc, i) => {
              const winner = getToolBySlug(uc.winnerSlug);
              return (
                <motion.div key={uc.slug} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}>
                  <Link to={`/use-cases/${uc.slug}`} className="group flex flex-col h-full border border-white/10 rounded-sm overflow-hidden hover:border-primary/50 transition-colors bg-surface/40">
                    <img src={uc.heroImage} alt={uc.title} className="w-full h-40 object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                    <div className="p-5 flex-1 flex flex-col">
                      <h3 className="text-white font-display font-bold text-base leading-snug">{uc.title}</h3>
                      {winner && <p className="text-xs font-mono-tag text-gold uppercase tracking-wider mt-3">Winner: {winner.name}</p>}
                      <p className="text-primary text-sm font-medium mt-3 inline-flex items-center gap-1 group-hover:gap-2 transition-all">See comparison <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" /></p>
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
